import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daytripideasnearpunemorachi() {



    const cardData =
    {
        keyword: 'Day Trip Ideas Near Pune Morachi Chincholi with Family',
        heading: 'Anand Krushi Paryatan Kendra: Day Trip Ideas Near Pune Morachi Chincholi with Family',
        headingDescription: 'Searching for memorable day trip ideas near Pune Morachi Chincholi with family? Look no further than Anand Krushi Paryatan Kendra, a beautiful 40-acre agri-tourism destination located just 55 km from Pune. Surrounded by lush greenery and filled with rural charm, it offers the perfect blend of nature, fun, and relaxation for a full day out. As one of the most family-friendly spots in the region, this destination features bullock cart and tractor rides, horse riding, boating, swimming, and a lively rain dance zone. Traditional village games and entertaining puppet and magic shows add a cultural touch to your outing.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi – Peacock Paradise",
    "description": "A scenic village known for over 2,000 free-roaming peacocks, peaceful farmlands, and a rich rural vibe. Watch peacocks dance, enjoy bullock cart rides, explore farm life, and indulge in local Maharashtrian meals. A perfect family retreat just 55 km from Pune."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "Located in Morachi Chincholi, this 40-acre agro-tourism farm offers tractor safaris, organic farming experiences, splash pools, pottery workshops, and unlimited thali lunches on banana leaves. Ideal for kids, parents, and even grandparents!"
  },
  {
    "title": "Hurda Party (Seasonal Experience)",
    "description": "From November to February, many farms in Morachi Chincholi host 'Hurda Parties' — where families can enjoy roasted green jowar served with chutneys, jaggery, and live folk music in open-air setups. A rustic winter delight!"
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "Just 25 km from Morachi Chincholi, this spiritual spot is one of the Ashtavinayak temples dedicated to Lord Ganesha. Combine spiritual peace with a rural day trip."
  },
  {
    "title": "Ghod River Backwaters",
    "description": "A calm and scenic location just a short drive from Morachi Chincholi. Great for a quick riverside picnic, birdwatching, and nature photography. Ideal for families looking for a quiet escape."
  },
  {
    "title": "Tulapur Historical Riverside",
    "description": "Visit the confluence of Bhima and Indrayani rivers, where Sambhaji Maharaj was martyred. A great educational trip for kids to learn about Maratha history and enjoy riverside views."
  },
  {
    "title": "Rural Games & Nature Trails",
    "description": "Let kids and adults enjoy traditional Indian games like kho-kho, lagori, sack race, and gilli-danda in open playgrounds. Many farms offer rope walks, bamboo swings, and shaded trails for birdwatching."
  },
  {
    "title": "Crafts & Pottery Workshop",
    "description": "At places like Anand Krushi, families can engage in pottery making, mud toy painting, and bamboo craft sessions. Take home a handmade souvenir and a smile!"
  },
  {
    "title": "Splash Pool & Rain Dance Zone",
    "description": "Cool off after rural adventures with a dip in the kids-friendly pool or groove under the rain dance zone with fun Marathi beats — a favorite for families on sunny weekends."
  },
  {
    "title": "Sunset Bonfire & Folk Music",
    "description": "Wrap up your day trip with a cozy bonfire, folk songs, dholki, and snacks under the stars — available at many agro-tourism spots on request. A lovely ending for family bonding."
  }
],




"services": [
  {
    "name": "Family-Friendly Day Trips Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is one of the best destinations for family-friendly day trips near Morachi Chincholi. With safe outdoor spaces, interactive farming activities, and plenty of fun for all age groups, it’s perfect for a wholesome rural getaway."
  },
  {
    "name": "Nature-Based Day Trip Ideas",
    "description": "Surrounded by lush farms and serene landscapes, Anand Krushi Paryatan Kendra offers immersive nature-based experiences like orchard walks, birdwatching, and eco trails, ideal for families seeking peaceful countryside time together."
  },
  {
    "name": "Adventure Day Outings for Families",
    "description": "Make your family outing exciting with rope climbing, rural obstacle courses, tire walks, and traditional games that blend fun and learning in a safe rural environment designed for all age groups."
  },
  {
    "name": "Educational Day Trips",
    "description": "Perfect for school groups and curious families, Anand Krushi Paryatan Kendra offers hands-on learning through guided farm tours, composting demos, irrigation knowledge, and insights into traditional and organic farming techniques."
  },
  {
    "name": "Picnic Day Trips with Kids",
    "description": "Enjoy a relaxing picnic under shady mango trees or in designated open-air huts. Kids can run, play, and interact with farm animals, while parents unwind with nature and freshly prepared local meals."
  },
  {
    "name": "Wildlife Watching Day Trips",
    "description": "Located in the Morachi Chincholi peacock belt, the farm is ideal for birdwatching and observing rural wildlife. Families can enjoy early morning bird walks or simply relax while spotting peacocks roaming freely."
  },
  {
    "name": "Cultural Heritage Day Trips",
    "description": "Let your kids and family immerse in Maharashtra’s rural culture with folk performances, bullock cart rides, traditional cooking, and village-style hospitality that offer more than just sightseeing—a real connection to local heritage."
  },
  {
    "name": "Relaxing Nature Day Trips",
    "description": "If you’re seeking a slow-paced escape, Anand Krushi Paryatan Kendra provides peaceful trails, hammock zones, meditation spots, and scenic backdrops that allow families to reconnect with nature and each other."
  },
  {
    "name": "Budget-Friendly Family Trips",
    "description": "Offering great value for money, the farm combines meals, activities, and nature experiences in affordable packages that suit both small families and large groups looking for a day of joy without overspending."
  },
  {
    "name": "Farm Visits and Agro Tourism",
    "description": "Take part in sowing seeds, watering plants, and even harvesting seasonal fruits. This farm visit turns into a memorable agro-tourism experience for both adults and kids eager to learn by doing."
  },
  {
    "name": "Waterfall Day Trips",
    "description": "In the monsoon, plan a combined visit with nearby seasonal waterfalls and return to the farm for hot local snacks and rustic hospitality. It’s a perfect blend of nature adventure and rural comfort."
  },
  {
    "name": "Historical Day Trips",
    "description": "Plan a day that includes local forts or temples near Morachi Chincholi, then unwind at the farm with heritage-based activities, making it a well-rounded cultural and educational family outing."
  },
  {
    "name": "Local Festivals and Events Day Trips",
    "description": "Visit during festival days to enjoy special cultural events at Anand Krushi Paryatan Kendra including Holi, Sankranti, and harvest celebrations—complete with folk music, food, and traditional décor."
  },
  {
    "name": "Weekend Family Day Trips",
    "description": "Just 1.5–2 hours from Pune, this makes for a perfect weekend plan where you can enjoy a full day of farm fun, good food, nature bonding, and fresh air—all wrapped in a peaceful setting."
  },
  {
    "name": "Fun Activities for Kids Day Trips",
    "description": "Children will love the open spaces, tractor rides, mud games, petting zoo, and creative workshops. Anand Krushi Paryatan Kendra is designed with kids in mind—safe, playful, and educational."
  }
],
"tableData": [
  ["Family-Friendly Day Trips Near Morachi Chincholi", "- Nature-Based Day Trip Ideas"],
  ["Adventure Day Outings for Families", "- Educational Day Trips"],
  ["Picnic Day Trips with Kids", "- Wildlife Watching Day Trips"],
  ["Cultural Heritage Day Trips", "- Relaxing Nature Day Trips"],
  ["Budget-Friendly Family Trips", "- Farm Visits and Agro Tourism"],
  ["Waterfall Day Trips", "- Historical Day Trips"],
  ["Local Festivals and Events Day Trips", "- Weekend Family Day Trips"],
  ["Fun Activities for Kids Day Trips", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Peacock Watching at Morachi Chincholi",
    "WhyChoosedescription": "Spend your morning among thousands of free-roaming peacocks in their natural tamarind grove habitat. Kids and adults alike will enjoy watching the vibrant birds dance and call, creating a magical rural experience."
  },
  {
    "WhyChooseheading": "Visit Anand Krushi Paryatan Kendra",
    "WhyChoosedescription": "Explore farm life with tractor and bullock cart rides, animal feeding, and organic vegetable picking. The center also offers traditional Maharashtrian meals, puppet shows, and fun games for children."
  },
  {
    "WhyChooseheading": "Picnic at Vadgaon Dam",
    "WhyChoosedescription": "Enjoy a relaxed afternoon by the calm waters of Vadgaon Dam. The surrounding greenery is perfect for family picnics, nature walks, and photography in a peaceful setting."
  },
  {
    "WhyChooseheading": "Explore Nighoj Potholes",
    "WhyChoosedescription": "Take a short trip to Nighoj (about 25 km away) to marvel at the fascinating geological potholes carved naturally by the Kukadi River. It’s an educational and awe-inspiring stop for curious minds."
  },
  {
    "WhyChooseheading": "Visit Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "Incorporate a spiritual touch to your day with a visit to this famous Ashtavinayak temple, just 40–45 km away. The temple’s serene ambiance is suitable for family prayers and cultural learning."
  },
  {
    "WhyChooseheading": "Enjoy Outdoor Activities at Anand Krushi",
    "WhyChoosedescription": "Engage in zip-lining, archery, rain dance, and cricket for an active and fun-filled day. These activities cater to both children and adults, making it a wholesome family adventure."
  },
  {
    "WhyChooseheading": "Relax at Ramling Mandir",
    "WhyChoosedescription": "End your day with a peaceful visit to Ramling Mandir, surrounded by nature and tranquility. It’s an ideal spot for reflection and quiet moments with family."
  }
]













    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Morachi Chincholi ideal for a family day trip from Pune?',
    answer: 'It’s just 1.5 hours from Pune and offers farm-based fun, peacock watching, tractor rides, and rural games that are enjoyable and safe for all age groups.',
  },
  {
    id: 'FAQ2',
    question: 'What are the top family-friendly activities in Morachi Chincholi?',
    answer: 'Families can enjoy bullock cart rides, nature walks, visit butterfly gardens, spot peacocks, play traditional games, and eat fresh farm meals together.',
  },
  {
    id: 'FAQ3',
    question: 'Is there a specific place to visit for organized experiences?',
    answer: 'Yes, places like Anand Krushi Paryatan Kendra offer well-managed experiences including pony rides, farm tours, and eco-friendly dining for families.',
  },
  {
    id: 'FAQ4',
    question: 'What kind of food is available for visitors?',
    answer: 'Most centers provide authentic Maharashtrian thalis with ingredients sourced from local farms — simple, healthy, and kid-friendly.',
  },
  {
    id: 'FAQ5',
    question: 'Are rest areas and facilities available for children and elders?',
    answer: 'Yes. Agro-tourism spots provide shaded seating, clean restrooms, and play zones for kids to relax and enjoy safely.',
  },
  {
    id: 'FAQ6',
    question: 'Do we need to carry anything special for the trip?',
    answer: 'Bring caps, sunscreen, water bottles, mosquito repellent, and a camera. Comfortable clothing and footwear are also advised.',
  },
  {
    id: 'FAQ7',
    question: 'Are animals or pets part of the agro-tourism experience?',
    answer: 'Yes! Children can interact with farm animals like cows, hens, goats, and even enjoy feeding them at many agro-tourism farms.',
  },
  {
    id: 'FAQ8',
    question: 'Is the destination stroller and elderly-friendly?',
    answer: 'Yes, most paths are flat and accessible. Just check in advance with the specific center to confirm facilities for elderly visitors.',
  },
  {
    id: 'FAQ9',
    question: 'Can we combine this trip with a visit to another place nearby?',
    answer: 'Yes, you can include Ranjangaon Mahaganpati Temple or Alandi as part of a full-day plan with Morachi Chincholi.',
  },
  {
    id: 'FAQ10',
    question: 'What is the best time for a family visit to Morachi Chincholi?',
    answer: 'The monsoon and early winter months (June to November) are perfect — the weather is pleasant, and peacocks are active and easily spotted.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Anjali Deshmukh, Pune',
    feedback: "Morachi Chincholi was perfect for our Sunday family trip. My kids loved the bullock cart ride and seeing peacocks up close. Great food and super peaceful atmosphere!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Vinay Joshi, Pimpri',
    feedback: "We took our parents and children for a one-day outing here. Everyone enjoyed it—from the tasty thali to the clean, natural surroundings. Highly recommended for a family day out!",
    rating: 5,
  },
];
















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Day Trip Ideas Near Pune Morachi Chincholi with Family",
  "image": "https://morachichincholi.in/assets/images/day-trip-ideas-family-morachi-chincholi.jpg",
  "description": "Plan memorable family-friendly day trips near Morachi Chincholi, Pune. Explore nature-based outings, adventure zones, waterfalls, educational farm visits, cultural experiences, wildlife watching, and picnic spots for all ages.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2379"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "620",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/day-trip-ideas-family"
  }
};



    return (
        <div>
<Helmet>
  <title>Day Trip Ideas Near Pune Morachi Chincholi with Family | Nature, Farm & Fun Activities</title>
  <meta 
    name="description" 
    content="Discover exciting and educational day trip ideas near Morachi Chincholi, Pune for families. Perfect for nature lovers, kids, and groups looking for picnics, adventure, waterfalls, farm visits, and local festivals." 
  />
  <meta 
    name="keywords" 
    content="Family-friendly day trips near Morachi Chincholi, Nature-based day trip ideas, Adventure day outings for families, Educational day trips, Picnic day trips with kids, Wildlife watching day trips, Cultural heritage day trips, Relaxing nature day trips, Budget-friendly family trips, Farm visits and agro tourism, Waterfall day trips, Historical day trips, Local festivals and events day trips, Weekend family day trips, Fun activities for kids day trips" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Daytripideasnearpunemorachi;